module.exports = __webpack_public_path__ + "prod/1.42.2/img/personnel-two.882e32bd.png";